module.exports = __webpack_public_path__ + "assets/ad942125ca7dbecbfbaafb19a22a1764.png";